import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useGetSectionandArea = () => {
  const [loading, setLoading] = useState(true);
  const [sectionandArea, setSectionandArea] = useState([]);

  const { enqueueSnackbar } = useSnackbar();

  const getSectionandArea = ({ zoneGuid } = {}) => {
    setLoading(true);

    axiosClient
      .get(`/InventoryGeo/Map/GetSectionandArea?GUID=${zoneGuid}`)
      .then(res => {
        if (res.status === 200) {
          setSectionandArea(prev => {
            return res.data?.value;
          });
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => enqueueSnackbar(err?.message, { variant: 'error' }))
      .finally(() => setLoading(false));
  };

  return [getSectionandArea, loading, sectionandArea, setSectionandArea];
};

export default useGetSectionandArea;
